/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ContractformatsQueryResponse } from '../../types/GetV1Contractformats.ts'

export const getV1ContractformatsQueryKey = () => [{ url: '/v1/ContractFormats' }] as const

export type GetV1ContractformatsQueryKey = ReturnType<typeof getV1ContractformatsQueryKey>

/**
 * {@link /v1/ContractFormats}
 */
export async function getV1Contractformats(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1ContractformatsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/ContractFormats`, ...requestConfig })
    return res
}

export function getV1ContractformatsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ContractformatsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ContractformatsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ContractformatsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Contractformats(config)
        },
    })
}

/**
 * {@link /v1/ContractFormats}
 */
export function useGetV1Contractformats<
    TData = ResponseConfig<GetV1ContractformatsQueryResponse>,
    TQueryData = ResponseConfig<GetV1ContractformatsQueryResponse>,
    TQueryKey extends QueryKey = GetV1ContractformatsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ContractformatsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ContractformatsQueryKey()

    const query = useQuery(
        {
            ...getV1ContractformatsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
